var render = function render(){var _vm=this,_c=_vm._self._c;return _c('react-wrapper',{attrs:{"component":_vm.landingPageReact}})
}
var staticRenderFns = []

export { render, staticRenderFns }